import { useEffect, useState } from "react";

import { verifiedWalletSubgraphClient } from "../adapters";
import {
  GET_VERIFIED_SECURITY,
  GET_VERIFIED_SECURITIES,
  GET_VERIFIED_PLATFORMS,
  GET_VERIFIED_USERS,
  GET_VERIFIED_USER,
  GET_VERIFIED_CURRENCIES,
  GET_VERIFIED_RWAS,
  GET_CASH_ISSUES_QUERY,
  GET_CASH_DEPOSITED_QUERY,
  GET_CASH_REDEMPTIONS_QUERY,
  GET_VERIFIED_USERS_BY_STATUS,
} from "../utils/queries/walletQueries";
import { useAccount, useConnectorClient } from "wagmi";
import { useGlobal } from "./globalContext";

export const getVerifiedSecurityByAddress = async (client, address) => {
  let data = [];
  if (client) {
    try {
      let result = await client.query({
        query: GET_VERIFIED_SECURITY,
        fetchPolicy: "network-only",

        variables: {
          id: address ?? "0x",
        },
      });
      data = result;
    } catch (e) {
      console.log("getWalletData catch", { e });
      console.log(e);
      return [];
    }
  }

  return data;
};
export function useVerifiedSecurity(securityAddress, isUpdate = "false") {
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  useEffect(() => {
    async function fetchPoolData() {
      if (chainId && securityAddress) {
        setLoading(true);
        let result = await getVerifiedSecurityByAddress(
          verifiedWalletSubgraphClient(chainId),
          securityAddress,
        );
        const data = result?.data;
        setState(data.security);
        setLoading(false);
      }
    }
    fetchPoolData();
  }, [address, chainId, isUpdate, securityAddress]);

  return { data: state, loading };
}

const getVerifiedSecuritiesList = async (client) => {
  let data = [];
  if (client) {
    try {
      let result = await client.query({
        query: GET_VERIFIED_SECURITIES,
        fetchPolicy: "network-only",
      });
      data = result;
    } catch (e) {
      console.log("getWalletSecurities catch", { e });
      console.log(e);
    }
  }

  return data;
};

const getVerifiedRWAs = async (client) => {
  let data = [];

  if (client) {
    try {
      let result = await client.query({
        query: GET_VERIFIED_RWAS,
        fetchPolicy: "network-only",
      });
      data = result;
    } catch (e) {
      console.log("getRWAs catch", { e });
      console.log(e);
    }
  }

  return data;
};

const getVerifiedCurrenciesList = async (client) => {
  let data = [];

  if (client) {
    try {
      let result = await client.query({
        query: GET_VERIFIED_CURRENCIES,
        fetchPolicy: "network-only",
      });
      data = result;
    } catch (e) {
      console.log("getWalletSecurities catch", { e });
      console.log(e);
    }
  }

  return data;
};

const getVerifiedUsersList = async (client, statuses) => {
  let data = [];

  if (client) {
    try {
      let result = await client.query({
        query: statuses ? GET_VERIFIED_USERS_BY_STATUS : GET_VERIFIED_USERS,
        variables: statuses
          ? {
              statuses: statuses,
            }
          : {},
        fetchPolicy: "network-only",
      });
      data = result;
    } catch (e) {
      console.log("getVerifiedUsersList catch", { error: e?.message });
    }
  }

  return data;
};

export function useVerifiedSecuritiesList() {
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  useEffect(() => {
    async function fetchPoolData() {
      if (chainId) {
        setLoading(true);
        let result = await getVerifiedSecuritiesList(
          verifiedWalletSubgraphClient(chainId),
        );
        const data = result.data || {};

        setState(data.securities || []);
        setLoading(false);
      }
    }
    fetchPoolData();
  }, [chainId]);

  return { data: state, loading };
}

export function useVerifiedRWALists() {
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  useEffect(() => {
    async function fetchRWAs() {
      if (chainId) {
        setLoading(true);
        let result = await getVerifiedRWAs(
          verifiedWalletSubgraphClient(chainId),
        );
        const data = result.data || {};
        setState(data.rwas || []);
        setLoading(false);
      }
    }
    fetchRWAs();
  }, [chainId, address]);

  return { data: state, loading };
}

export function useVerifiedCurrenciesList() {
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  useEffect(() => {
    async function fetchPoolData() {
      if (chainId) {
        setLoading(true);
        let result = await getVerifiedCurrenciesList(
          verifiedWalletSubgraphClient(chainId),
        );
        const data = result.data || {};
        setState(data.currencies || []);
        setLoading(false);
      }
    }
    fetchPoolData();
  }, [chainId]);

  return { data: state, loading };
}

export function useVerifiedUsers(statuses) {
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(true);
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  useEffect(() => {
    async function fetchPoolData() {
      if (chainId) {
        let result = await getVerifiedUsersList(
          verifiedWalletSubgraphClient(chainId),
          statuses,
        );
        const data = result.data || {};
        setState(data.users || []);
        setLoading(false);
      }
    }
    fetchPoolData();
  }, [chainId]);

  return { data: state, loading };
}

export const getVerifiedUserByAddress = async (client, address) => {
  let data = [];
  if (client) {
    try {
      let result = await client.query({
        query: GET_VERIFIED_USER,
        fetchPolicy: "network-only",

        variables: {
          id: address ?? "0x",
        },
      });
      data = result;
    } catch (e) {
      console.log("getWalletData catch", { e });
      console.log(e);
    }
  }

  return data;
};

const getVerifiedPlatformsList = async (client) => {
  let data = [];
  if (client) {
    try {
      let result = await client.query({
        query: GET_VERIFIED_PLATFORMS,
        fetchPolicy: "network-only",
      });
      data = result;
    } catch (e) {
      console.log("getWalletData catch", { e });
      console.log(e);
    }
  }

  return data;
};

export function useVerifiedUser(_userAddress) {
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(true);

  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  useEffect(() => {
    async function fetchPoolData() {
      let result = await getVerifiedUserByAddress(
        verifiedWalletSubgraphClient(chainId),
        _userAddress.toLowerCase(),
      );
      const data = result.data || {};
      setState(data.user || {});
      setLoading(false);
    }
    fetchPoolData();
  }, [address, chainId]);

  return { data: state, loading };
}

export function useVerifiedPlatforms() {
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(true);
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  useEffect(() => {
    async function fetchPoolData() {
      let result = await getVerifiedPlatformsList(
        verifiedWalletSubgraphClient(chainId),
      );
      const data = result.data || {};
      setState(data.platforms || {});
      setLoading(false);
    }
    fetchPoolData();
  }, [chainId]);

  return { data: state, loading };
}

const getAllCashRedemptions = async (client) => {
  let data = [];
  if (client) {
    try {
      let result = await client.query({
        query: GET_CASH_REDEMPTIONS_QUERY,
        fetchPolicy: "network-only",
      });
      data = result;
    } catch (e) {
      console.log("getAllCashRedemptions catch", { e });
    }
  }

  return data;
};

export function useGetAllCashRedemptions() {
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;

  useEffect(() => {
    async function fetchCashRedemptions() {
      if (chainId) {
        setLoading(true);
        let result = await getAllCashRedemptions(
          verifiedWalletSubgraphClient(chainId),
        );

        const data = result.data || {};

        setState(data.cashRedemptions_collection || []);
        setLoading(false);
      }
    }
    fetchCashRedemptions();
  }, [chainId]);

  return { data: state, loading };
}
